import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import DictionariesCoefficientModel, {
  UpdateDictionariesCoefficientModel,
} from "../../../viewModels/Dictionaries/DictionariesCoefficientModel";

import IDictionariesCoefficientDto from "../../../dto/Dictionaries/IDictionariesCoefficientDto";
import SortObject from "../../../types/SortObject";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  coefficients: Array<DictionariesCoefficientModel>;

  total: number;
  pageSize: number;
  page: number;
  sort: SortObject;

  coefficientIdToEdit: number;
  isEditCoefficientDrawerOpen: boolean;
  isEditCoefficientDrawerLoading: boolean;
} = {
  loading: true,
  loadingData: true,

  coefficients: undefined!,

  total: undefined!,
  pageSize: 10,
  page: 1,

  sort: undefined!,

  coefficientIdToEdit: undefined!,
  isEditCoefficientDrawerLoading: false,
  isEditCoefficientDrawerOpen: false,
};

const dictionariesCoefficientsSlice = createSlice({
  name: "dictionariesCoefficients",
  initialState,
  reducers: {
    loadCoefficients(state) {
      state.loadingData = true;
      state.page = 1;
    },
    loadCoefficientsSuccess(
      state,
      action: PayloadAction<{
        coefficients: Array<DictionariesCoefficientModel>;
        total: number;
      }>,
    ) {
      const { coefficients, total } = action.payload;
      state.loading = false;
      state.loadingData = false;
      state.coefficients = coefficients;
      state.total = total;
    },
    loadCoefficientsError(state) {
      state.loading = false;
      state.loadingData = false;
    },
    changeTable(state, action: PayloadAction<{ page: number; pageSize: number; sort: SortObject }>) {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.sort = action.payload.sort;
      state.loadingData = true;
    },
    search(state) {
      state.loadingData = true;
    },
    openEditCoefficientDrawer(state, action: PayloadAction<number | undefined>) {
      state.coefficientIdToEdit = action.payload!;
      state.isEditCoefficientDrawerOpen = true;
    },
    closeEditCoefficientDrawer(state) {
      if (!state.isEditCoefficientDrawerLoading) {
        state.coefficientIdToEdit = undefined!;
        state.isEditCoefficientDrawerOpen = false;
      }
    },

    updateCoefficient(state, _action: PayloadAction<UpdateDictionariesCoefficientModel>) {
      state.isEditCoefficientDrawerLoading = true;
    },
    updateCoefficientSuccess(state, action: PayloadAction<IDictionariesCoefficientDto>) {
      const index = state.coefficients.findIndex((x) => x.id === action.payload.id);
      state.coefficients[index] = action.payload;
      state.isEditCoefficientDrawerLoading = false;
      state.isEditCoefficientDrawerOpen = false;
    },
    updateCoefficientError(state) {
      state.isEditCoefficientDrawerLoading = false;
    },
  },
});

export default dictionariesCoefficientsSlice;
